import { render, staticRenderFns } from "./DownloadBanner.vue?vue&type=template&id=dd08e1a4&scoped=true"
import script from "./DownloadBanner.vue?vue&type=script&lang=js"
export * from "./DownloadBanner.vue?vue&type=script&lang=js"
import style0 from "./DownloadBanner.vue?vue&type=style&index=0&id=dd08e1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd08e1a4",
  null
  
)

export default component.exports